import { metrics } from "../../data/analytics";

export function Statistics() {
  return <section className="metrics-band" aria-label="reviewbub statistics">{metrics.map((metric) => <article className="metric-card blue" key={metric.label}><span>{metric.label}</span><strong>{metric.value}</strong><em>Built for measurable visibility</em></article>)}</section>;
}
